export const IOF = 0.0738;
export const ADJUST_VALUE = 0.931272;
export const PARTNER_77_ID = 38;

export const formatPolicyStatus = (status) => PolicyStatus[status] || '';
export const formatProposalStatus = (status) => ProposalStatus[status] || '';
export const formatPartnerProduct = (product) => PartnerProduct[product] || '';

const ProposalStatus = {
  awaiting_inspection: 'Aguardando vistoria',
  awaiting_vistei: 'Aguardando aprovação de fotos',
  awaiting_complementar: 'Aguardando fotos complementares',
  awaiting_registration: 'Aguardando cadastro',
  awaiting_complementar_report: 'Aguardando aprovação das fotos complementares',
  awaiting_payment: 'Aguardando pagamento',
  awaiting_mga_communication: 'Aguardando comunicação de emissão do MGA',
  activated: 'Ativada',
  rejected: 'Rejeitada',
  cancelled: 'Cancelada',
  expired: 'Expirada',
};

const PolicyStatus = {
  active: 'Ativo',
  canceled: 'Cancelado',
  awaiting_cancellation: 'Aguardando cancelamento',
};

export const PartnerProduct = {
  corporate: 'corporate',
  dealer: 'dealer',
  runoff: 'runOff',
  franchise: 'franquias',
  advisory: 'assessorias',
  enterprise: 'enterprise',
};

export const hasPermission = (permissions, feature) => {
  const menuIndex = permissions.findIndex((i) => i.feature === feature);
  if (menuIndex === -1) return;
  return permissions[menuIndex].hasPermission;
};
